<span
  class="ant-skeleton-avatar"
  [class.ant-skeleton-avatar-square]="nzShape === 'square'"
  [class.ant-skeleton-avatar-circle]="nzShape === 'circle'"
  [class.ant-skeleton-avatar-lg]="nzSize === 'large'"
  [class.ant-skeleton-avatar-sm]="nzSize === 'small'"
  [ngStyle]="styleMap">
</span>
